<template>
  <div v-if="which_to_show">
    <!--        <div>组件测试</div>-->
    <!--        <button @click='toShow'>点击显示子组件</button>-->
    <!--        <div>{{which_to_show}}</div>-->
    <!--        <h2>{{text_tip}}</h2>-->
    <component v-bind:is="which_to_show" :params="act_params"></component>
  </div>
</template>

<script>
// import Wp_jd_select from "../pages/Wp_jd_select";
// import Wp_jd_changelink from "../pages/Wp_jd_changelink";
// import Wp_jd_events from "../pages/Wp_jd_events";
// import Wp_jd_data from "../pages/Wp_jd_data";
// import Wp_jd_my from "../pages/Wp_jd_my";
// import Wp_mini_my from "./Wp_mini_my";

// import Wp_robot_tools from "../pages_childs/Wp_robot_tools";
// import Wp_all_search_page from "../pages/Wp_all_search_page";
// import Wp_jd_home_simple from "../pages/Wp_jd_home_simple";
import { Toast } from 'vant'

export default {
  name: 'Wp_mini_config',

  components: {
    // Wp_mini_my,
    // Wp_jd_my,
    // Wp_jd_data,
    // Wp_jd_events,
    // Wp_jd_select,
    // Wp_jd_changelink,
    'Wp_jd_select': () => import('../pages/Wp_jd_select'),
    'Wp_jd_changelink': () => import('../pages/Wp_jd_changelink'),
    'Wp_jd_events': () => import('../pages/Wp_jd_events'),
    'Wp_jd_data': () => import('../pages/Wp_jd_data'),
    'Wp_order_count': () => import('../pages_childs/Wp_order_count'),
    'Wp_jd_order_flow': () => import('../pages/Wp_jd_order_flow'),
    'Wp_my_child_member': () => import('../pages_childs/Wp_my_child_member'),
    'Wp_jd_my': () => import('../pages/Wp_jd_my'),
    'Wp_my_pay_data': () => import('../pages_childs/Wp_my_pay_data'),
    'Wp_mini_my': () => import('./Wp_mini_my'),
    'Wp_mini_login': () => import('./Wp_mini_login'),
    'Wp_mini_event': () => import('./Wp_mini_event'),
    'Wp_mini_member': () => import('./Wp_mini_member'),
    'Wp_mini_guide': () => import('./Wp_mini_guide'),
    'Wp_mini_upgrade': () => import('./Wp_mini_upgrade'),
    'Wp_mini_home': () => import('../pages/Wp_jd_home'),
    'Wp_jd_action_info': () => import('../pages_childs/Wp_jd_action_info'),
    'Wp_search_page': () => import('../pages_childs/Wp_search_page'),
    'Wp_wx_public_regist': () => import('../pages_wx_public/Wp_wx_public_regist'),
    'Wp_my_modify_password': () => import('../pages_childs/Wp_my_modify_password'),
    'Wp_robot_tools': () => import('../pages_childs/Wp_robot_tools'),
    'Wp_all_search_page': () => import('../pages/Wp_all_search_page'),
    'Wp_jd_home_simple': () => import('../pages/Wp_jd_home_simple'),
    'Wp_jd_article': () => import('../pages_childs/Wp_jd_article'),
    'Wp_reset_password': () => import('../pages_childs/Wp_reset_password'),
    'Wp_jd_gift': () => import('../pages/Wp_jd_gift'),
  },

  data () {
    return {
      which_to_show: '',
      text_tip: '',
      search_value: '',

      act_params: {},
    }
  },

  created () {
    this.initDataToPage()
    // 测试账号id
    // 超级会员（S101）：C56565C08708F8D59C9DCD6AD8D60BA6
    // 普通会员（W100016）：2486C63B300086A3C2E8E91D6748ABBC
  },

  methods: {
    initDataToPage () {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '加载中...'
      })
      let id = this.$common.getUrlKey('id')
      // this.text_tip = this.$common.getUrlKey("_t");
      this.search_value = this.$common.getUrlKey('search')
      this.$log('id = ' + id)
      if (!id) {
        //如果openid为空，需要另做处理（跳转到小程序首页）

        // this.$dialog.alert({
        //     message: "用户标识异常，请退出重新登录"
        // })

        toast.clear()

        let param_page = this.$common.getUrlKey('p')
        if (param_page === 'wx_public_regist' || param_page === 'reset_password') {
          this.showPage()
        } else {
          //如果openid为空，需要另做处理（跳转到小程序首页）
          // this.showPage();

          this.$dialog.alert({
            message: '用户标识异常，请退出重新登录'
          })
        }
      } else {
        // let openid = this.$common.getUrlKey("openid");
        // this.$common.gloabl_wx_openid = openid;

        //根据openid从服务器获取微信用户信息
        this.$getGloabl_WxUserinfo(id, (login_status) => {
          toast.clear()
          if (login_status && login_status !== 'none') {
            let userInfo = this.$common.gloabl_wx_mini_user_info

            let channel_name = userInfo.channel_name
            this.$getPid(channel_name, res => {
              // let _channel_id=res.data.channel_id;
              let _channel_id = ''
              // let _channel_name = '';
              let _pdd_pid = ''
              let _taobao_pid = ''
              if (res && res.code === 200) {
                if (res.data) {
                  if (res.data.jd_channel_id) {
                    _channel_id = res.data.jd_channel_id
                  }
                  // if(res.data.channel_name){
                  //     _channel_name=res.data.channel_name;
                  // }
                  if (res.data.pdd_channel_id) {
                    _pdd_pid = res.data.pdd_channel_id
                  }
                  if (res.data.tb_channel_id) {
                    _taobao_pid = res.data.tb_channel_id
                  }
                }

                let user = {
                  username: channel_name,
                  // userId: loginInfo.id,
                  pid: _channel_id,
                  // alipay: loginInfo.u_alpay,//支付宝账号
                  // bankName: loginInfo.u_bank,//开户行
                  // cardNomber: loginInfo.u_card,//银行卡号
                  // bank_account: loginInfo.u_bank_account,// 账号名称
                  openid: userInfo.open_id,//微信openid
                  // truename: loginInfo.u_payname,// 真实姓名
                  // userType: loginInfo.u_type,// 0群主1代理商
                  userType: userInfo.role_id,  // 0群主1代理商
                  userPhone: userInfo.phone,//手机号
                  pdd_pid: _pdd_pid,
                  taobao_pid: _taobao_pid,

                }
                this.$store.commit('login', user)

                //获取数据后，不论成功还是失败，都跳转界面
                this.showPage()

              }
            })

          } else {
            //如果登录状态为空或者为none，则跳转小程序首页
            this.$dialog.alert({
              message: '用户信息数据查询失败，请退出重新登录'
            })
          }

        })

        // let autologin = this.$common.getUrlKey("autologin");
        // if(autologin && autologin === "true"){
        //
        //
        // }else{
        //     this.showPage();
        // }
      }
    },

    showPage () {
      // let url = window.location.href;
      // this.$log(url);
      let param_page = this.$common.getUrlKey('p')
      this.$log('p = ' + param_page)
      if (param_page === 'select') {
        this.which_to_show = 'Wp_jd_select'
        // this.which_to_show = this.components.Wp_jd_select;
        if (this.search_value) {
          this.which_to_show = 'Wp_jd_select?search=' + this.search_value
        }
      } else if (param_page === 'changelink') {
        this.which_to_show = 'Wp_jd_changelink'
      } else if (param_page === 'events') {
        this.which_to_show = 'Wp_jd_events'
      } else if (param_page === 'data') {
        this.which_to_show = 'Wp_jd_data'
      } else if (param_page === 'data1') {
        this.which_to_show = 'Wp_order_count'
      } else if (param_page === 'data2') {
        this.which_to_show = 'Wp_jd_order_flow'
      } else if (param_page === 'data3') {
        this.which_to_show = 'Wp_my_child_member'
      } else if (param_page === 'my') {
        this.which_to_show = 'Wp_jd_my'
      } else if (param_page === 'paydata') {
        this.which_to_show = 'Wp_my_pay_data'
      } else if (param_page === 'mini_my') {
        this.which_to_show = 'Wp_mini_my'
      } else if (param_page === 'mini_login') {
        this.which_to_show = 'Wp_mini_login'
      } else if (param_page === 'mini_event') {
        this.which_to_show = 'Wp_mini_event'
      } else if (param_page === 'mini_member') {
        this.which_to_show = 'Wp_mini_member'
      } else if (param_page === 'mini_guide') {
        this.which_to_show = 'Wp_mini_guide'
      } else if (param_page === 'mini_upgrade') {
        this.which_to_show = 'Wp_mini_upgrade'
      } else if (param_page === 'home') {
        this.which_to_show = 'Wp_mini_home'
      } else if (param_page === 'action_info') {

        let act = this.$common.getUrlKey('act')
        if (act) {
          this.act_params = {
            actId: act,
          }
        }
        this.which_to_show = 'Wp_jd_action_info'

      } else if (param_page === 'search_page') {
        this.which_to_show = 'Wp_search_page'
      } else if (param_page === 'wx_public_regist') {
        this.which_to_show = 'Wp_wx_public_regist'
      } else if (param_page === 'modify_password') {
        this.which_to_show = 'Wp_my_modify_password'
      } else if (param_page === 'robot_tools') {
        this.which_to_show = 'Wp_robot_tools'
      } else if (param_page === 'all_search') {
        this.which_to_show = 'Wp_all_search_page'
      } else if (param_page === 'home_s') {
        this.which_to_show = 'Wp_jd_home_simple'
      } else if (param_page === 'article') {
        this.which_to_show = 'Wp_jd_article'
      } else if (param_page === 'reset_password') {
        this.which_to_show = 'Wp_reset_password'
      } else if (param_page === 'gift') {
        this.which_to_show = 'Wp_jd_gift'
      } else {
        this.which_to_show = 'Wp_jd_select'
      }
    },

    toShow () {
      let arr = ['first', 'Wp_jd_select', 'Wp_jd_my']
      let index = arr.indexOf(this.which_to_show)
      if (index < 2) {
        this.which_to_show = arr[index + 1]
      } else {
        this.which_to_show = arr[0]
      }
    },

  }
}
</script>

<style scoped>

</style>